const legendItems = [
  {
    key: 'active',
    label: 'Enabled Anchor',
    data: { anchorPointName: 'Enabled Anchor' },
    isDisabled: false
  },
  {
    key: 'disabled',
    label: 'Disabled Anchor',
    data: { anchorPointName: 'Disabled Anchor' },
    isDisabled: true
  }
];

export { legendItems };
